export const PUBLIC_URL = window.env.PUBLIC_URL || process.env.PUBLIC_URL;
export const UrlPathMain = PUBLIC_URL + "/";
export const UrlPathCustomer = PUBLIC_URL + "/customer";
export const UrlPathCustomerPreferences = PUBLIC_URL + "/customerpreferences";
export const UrlPathBonifiedInteractions = PUBLIC_URL + "/bonifiedinteractions";
export const UrlPathRegistration = PUBLIC_URL + "/register";
export const UrlPathConsent = PUBLIC_URL + "/consent";
export const UrlPathCoupon = PUBLIC_URL + "/coupons";
export const UrlPathCouponTemplates = PUBLIC_URL + "/coupon-templates";
export const UrlPathBonusPremium = PUBLIC_URL + "/premiumcoupons";
export const UrlPathSimulator = PUBLIC_URL + "/simulator";
export const UrlPathInviteFamily = PUBLIC_URL + "/invitefamily";
export const UrlPathInviteFriend = PUBLIC_URL + "/invitefriend";
export const UrlPathBlockCustomer = PUBLIC_URL + "/blockcustomer";
export const UrlPathReceipts = PUBLIC_URL + "/receipts";
export const UrlPathGameZone = PUBLIC_URL + "/gamezone";
export const UrlPathMissionCenter = PUBLIC_URL + "/missions";

const unauthenticatedPaths = [UrlPathMain, UrlPathRegistration, UrlPathConsent];

export const isUnauthenticatedPath = () => unauthenticatedPaths.includes(window.location.pathname);
